import { X } from "lucide-react";
import { LucideProps } from "lucide-react";

interface CloseIconProps extends LucideProps {
  className?: string;
}

export default function CloseIcon({ className = "", size = 24, ...props }: CloseIconProps) {
  return <X className={className} size={size} {...props} />;
}
